import { Spinner as ChakraSpinner, type SpinnerProps } from '@chakra-ui/react';

export const Spinner = (props: SpinnerProps) => <ChakraSpinner {...props} />;
